import { Route } from '@angular/router';
import { AuthGuard } from '@app/core/auth/guards/auth.guard';
import { NoAuthGuard } from '@app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from '@app/layout/layout.component';
import { InitialDataResolver } from '@app/app.resolvers';
import { InstitutionOrderResolver } from './modules/institution/institution-orders/institution-orders.resolvers';

// @formatter:off
// tslint:disable:max-line-length
export const appRoutes: Route[] = [

    // Redirect empty path to '/bulk-orders'
    {path: '', pathMatch : 'full', redirectTo: 'bulk-orders'},

    // Backwards-compatible route for the old hire centre entrypoint.
    {path: 'hire-centre', pathMatch : 'full', redirectTo: 'casual-orders/casual-orders'},

    // Redirect signed in user to the '/bulk-orders'
    //
    // After the user signs in, the sign in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    {path: 'signed-in-redirect', pathMatch : 'full', redirectTo: 'bulk-orders'},

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'confirmation-required', loadChildren: () => import('@app/modules/auth/confirmation-required/confirmation-required.module').then(m => m.AuthConfirmationRequiredModule)},
            {path: 'forgot-password', loadChildren: () => import('@app/modules/auth/forgot-password/forgot-password.module').then(m => m.AuthForgotPasswordModule)},
            {path: 'reset-password', loadChildren: () => import('@app/modules/auth/reset-password/reset-password.module').then(m => m.AuthResetPasswordModule)},
            {path: 'sign-in', loadChildren: () => import('@app/modules/auth/sign-in/sign-in.module').then(m => m.AuthSignInModule)}
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'sign-out', loadChildren: () => import('@app/modules/auth/sign-out/sign-out.module').then(m => m.AuthSignOutModule)},
            {path: 'change-password-required', loadComponent: () => import('@app/modules/auth/change-password.component').then(m => m.ChangePasswordComponent)}
        ]
    },

    // Landing routes
    {
        path: '',
        component  : LayoutComponent,
        data: {
            layout: 'empty'
        },
        children   : [
            {path: 'home', loadChildren: () => import('@app/modules/landing/home/home.module').then(m => m.LandingHomeModule)},
        ]
    },

    // Admin routes
    {
        path       : '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component  : LayoutComponent,
        resolve    : {
            initialData: InitialDataResolver,
        },
        children   : [
            {
                path: 'operator',
                loadComponent: () => import('./modules/operator/operator.component').then(m => m.OperatorComponent),
                children: [{path: ':order_id', outlet: 'orderdetails',
                    loadComponent: () => import('./modules/institution/institution-orders/institution-order-details-drawer/institution-order-details-drawer.component').then(m => m.InstitutionOrderDetailsDrawerComponent),
                    resolve: {order: InstitutionOrderResolver}}]
            },
            //Hire Centre Routes
            {
                path: 'casual-orders',
                loadChildren: () => import('@app/modules/casual-orders/casual-orders.module').then(m => m.CasualOrdersModule)
            },
            {
                path: 'bulk-orders',
                loadChildren: () => import('@app/modules/bulk-orders/bulk-orders.module').then(m => m.BulkOrdersModule)
            },
            {
                path: 'bulk-individual-orders',
                loadChildren: () => import('@app/modules/bulk-individual-orders/bulk-individual-orders.module').then(m => m.BulkIndividualOrdersModule)
            },
            {
                path: 'institution',
                loadChildren: () => import('@src/app/modules/institution/institution.module').then(m => m.InstitutionModule)
            },
            {   
                path: 'system', 
                loadChildren: () => import('@app/modules/system/system.module').then(m => m.SystemModule)
            },
            {
                path: 'calendar',
                loadChildren: () => import('@app/modules/calendar/calendar.module').then(m => m.CalendarModule)
            }


        ]
    }
];
